import { faChevronRight, faSalad } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import useKeyboardAction from '../../shared/hooks/useKeyboardAction.ts';
import NutritionTracker from './NutritionTracker.jsx';

function NutritionCover(props) {
  const { closeTrackers } = props;
  const { t } = useTranslation();

  const [areaPicker, setAreaPicker] = useState(true);
  const [openNutrition, setOpenNutrition] = useState(false);

  const handleNutrition = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenNutrition(true);
    }, 500);
  };

  useKeyboardAction(() => {
    closeTrackers();
  }, 'Escape');

  useEffect(() => {
    if (openNutrition) {
      const nutrition = document.getElementById('snm-nutrition');
      setTimeout(() => {
        nutrition?.classList.add('slide-in');
      }, 300);
    }
  }, [openNutrition]);

  useEffect(() => {
    if (areaPicker) {
      const main = document.getElementById('snm-main');
      setTimeout(() => {
        main?.classList.add('slide-in');
      }, 300);
    }
  }, [areaPicker]);

  const handleBackToMain = () => {
    if (openNutrition) {
      const nutrition = document.getElementById('snm-nutrition');
      nutrition?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenNutrition(false);
        setAreaPicker(true);
      }, 500);
    }
  };

  return (
    <>
      {areaPicker && (
        <div id="snm-main" className="tracker-container">
          <div className="ind-tracker mood">
            <h2 className="title">{t('T134')}</h2>
            <button
              className="mood-area"
              onClick={handleNutrition}
              type="button"
              aria-label={t('T349')}
            >
              <div>
                <FontAwesomeIcon icon={faSalad} className="mood-icon" /> {t('T349')}{' '}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <div className="buttons mood">
            <Button onClick={props.closeTrackers} variant="secondary" color="dark">
              {t('T015')}
            </Button>
          </div>
        </div>
      )}{' '}
      {openNutrition && (
        <NutritionTracker handleBackToMain={handleBackToMain} closeTrackers={props.closeTrackers} />
      )}
    </>
  );
}
export default NutritionCover;
